import { render, staticRenderFns } from "./NtcEdtConfirmationDialog.vue?vue&type=template&id=7d91779a&scoped=true"
import script from "./NtcEdtConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./NtcEdtConfirmationDialog.vue?vue&type=script&lang=ts"
import style0 from "./NtcEdtConfirmationDialog.vue?vue&type=style&index=0&id=7d91779a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d91779a",
  null
  
)

export default component.exports